import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/deals/Page";

export const PATH = "/vendors/deals";

function DealsIndex() {
	return (
		<>
			<NskHead title="案件一覧" />
			<Component />
		</>
	);
}

export default DealsIndex;
